module.exports = __webpack_public_path__ + "img/10.4a798e29.png";